import { Option } from '@inrev/core';
import * as z from 'zod';
import { initializeExposure, exposureSchema, nonNegativeCurrencySchema, suretyAccountBondingLineSchema } from '../../../utils.mjs';

var Exposure;
(function (Exposure) {
    Exposure.initialize = () => ({
        quotes: 0,
        bonds: 0,
        total: 0,
        bid: initializeExposure(),
        bid_to_final: initializeExposure(),
        final: initializeExposure(),
    });
    Exposure.schema = exposureSchema.extend({
        bid: exposureSchema,
        bid_to_final: exposureSchema,
        final: exposureSchema,
    });
})(Exposure || (Exposure = {}));
var Metadata;
(function (Metadata) {
    Metadata.schema = z.object({
        bondingLine: suretyAccountBondingLineSchema.nullish(),
        largestProjectCompleted: nonNegativeCurrencySchema.nullish(),
        lostAPaymentSuit: z.boolean().nullish(),
        failedToCompleteAProject: z.boolean().nullish(),
        constructionProjectsGrossLossGt10PercentLast36Months: z.boolean().nullish(),
        currentConstructionProjectExpectedGrossLoss: z.boolean().nullish(),
        requestedSingleLimit: nonNegativeCurrencySchema.nullish(),
        requestedAggregateLimit: nonNegativeCurrencySchema.nullish(),
    });
})(Metadata || (Metadata = {}));
const contractHistoryMetadataKeys = [
    "largestProjectCompleted",
    "lostAPaymentSuit",
    "failedToCompleteAProject",
    "constructionProjectsGrossLossGt10PercentLast36Months",
    "currentConstructionProjectExpectedGrossLoss",
];
const hasContractHistoryMetadata = (metadata) => {
    if (Option.isNone(metadata)) {
        return false;
    }
    return contractHistoryMetadataKeys.some((key) => Object.prototype.hasOwnProperty.call(metadata, key));
};
var Profitability;
(function (Profitability) {
    Profitability.schema = z.object({
        profitableYtd: z.boolean().nullish(),
        profitableLastFye: z.boolean().nullish(),
        profitableYearPriorToLastFye: z.boolean().nullish(),
        effectiveFyeYear: z.number(),
    });
})(Profitability || (Profitability = {}));

export { Exposure, Metadata, Profitability, hasContractHistoryMetadata };
